// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RemoveFromBasketRequestModel from '../../model/remove-from-basket-request-model';
import RemoveFromBasketRequestDTO from '../dto/remove-from-basket-request-dto';
import dtoSchema from '../schemas/remove-from-basket-request-schema';

export default abstract class RemoveFromBasketRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RemoveFromBasketRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.userId = data.userId;
      this.publicBasketId = data.publicBasketId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {uuid}
  */
  publicBasketId?: string;

  static toModel(dto: DeepPartial<RemoveFromBasketRequestDTO>): RemoveFromBasketRequestModel;
  static toModel(dto: DeepPartial<RemoveFromBasketRequestDTO> | undefined | null): RemoveFromBasketRequestModel | undefined;
  static toModel(dto: DeepPartial<RemoveFromBasketRequestDTO> | undefined | null): RemoveFromBasketRequestModel | undefined {
    return dto ? new RemoveFromBasketRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RemoveFromBasketRequestModel> | RemoveFromBasketRequestModel): RemoveFromBasketRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      userId: unwrapped.userId,
      publicBasketId: unwrapped.publicBasketId,
    } as RemoveFromBasketRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RemoveFromBasketRequestModel, can not map to RemoveFromBasketRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
